import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Sidebar from '../mendepartmentdetails/Sidebar';
import DepartmentImage from '../../../assets/image/department/side-view-man-taking-notes-ambulance-car.jpg';
import DepartmentImage2 from '../../../assets/image/department/5995353.jpg';

function PublicSafety() {

  const [Faq, setFaq] = useState(0);

  const Drop = [
    {
      Que: "How can I get involved in public safety programs?",
      Answer: "Community members can participate in neighborhood watch programs, attend safety workshops, and volunteer for emergency preparedness events."
    },
    {
      Que: "What resources are available for public safety education?",
      Answer: "The Department of Public Safety offers workshops, online guides, and community outreach programs to enhance public safety awareness."
    }
  ];

  return (
    <>
      <section className="department-details-section">
        <div className="container">
          <div className="row">

            {/* Sidebar */}
            <div className="col-12 col-lg-4 col-xl-4">
              <Sidebar />
            </div>

            {/* Main Content */}
            <div className="col-lg-8">
              <div className="department-details-imgbox">
                <img src={DepartmentImage} className="img-fluid" alt="Public Safety" />
              </div>

              <div className="department-details-content-box">
                <h4 className="department-details-title">Public Safety</h4>
                <p>
                  The Department of Public Safety ensures the safety and security of the community through law enforcement, emergency response, and public safety education.<br />
                  DPS works closely with local agencies to provide essential services like policing, fire response, and disaster preparedness, aiming to create a safer environment for all residents.
                </p>
              </div>

              <div className="department-details-box">
                <div className="department-details-policy">
                  <span>
                    Dedicated to community safety and rapid response in emergencies.
                  </span>
                </div>
                <p>
                  DPS focuses on proactive crime prevention, traffic safety, and disaster management to safeguard the well-being of the community.
                </p>
              </div>

              <div className="department-details-benefits-inner-box">
                <div className="row row-gutter-30">
                  <div className="col-lg-6">
                    <div className="department-details-benefits-box-image">
                      <img src={DepartmentImage2} className="img-fluid" alt="Public Safety Services" />
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <div className="department-details-benefits-box">
                      <h3>Our Benefits</h3>
                      <p>
                        Rapid response teams, community policing programs, and disaster readiness initiatives.
                      </p>
                      <ul className="list-unstyled list-style" style={{ marginTop: '-15px' }}>
                        <li>
                          <Link to="/department/public-safety/community-policing">
                            <i className="fa-solid fa-circle-arrow-right" style={{ marginRight: '5px' }} />
                            Community Policing and Crime Prevention
                          </Link>
                        </li>
                        <li>
                          <Link to="/department/public-safety/fire-rescue">
                            <i className="fa-solid fa-circle-arrow-right" style={{ marginRight: '5px' }} />
                            Fire and Rescue Services
                          </Link>
                        </li>
                        <li>
                          <Link to="/department/public-safety/traffic-safety">
                            <i className="fa-solid fa-circle-arrow-right" style={{ marginRight: '5px' }} />
                            Traffic and Road Safety Enforcement
                          </Link>
                        </li>
                        <li>
                          <Link to="/department/public-safety/disaster-response">
                            <i className="fa-solid fa-circle-arrow-right" style={{ marginRight: '5px' }} />
                            Disaster Response and Recovery Operations
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <div className="accordian-box">
                {Drop.map((items, index) => (
                  <div className={`accordian-box-item ${Faq !== index && "active"}`} key={index}>
                    <div className="accordian-title">
                      <h5>{items.Que}</h5>
                      <i className="fa-solid fa-angle-right" onClick={() => setFaq(index)} />
                    </div>

                    {Faq === index && (
                      <div className="accordian-content" style={{ display: "block" }}>
                        <p>{items.Answer}</p>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default PublicSafety;
